import { render, staticRenderFns } from "./warehousing.vue?vue&type=template&id=c9183cc4&"
import script from "./warehousing.vue?vue&type=script&lang=js&"
export * from "./warehousing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9183cc4')) {
      api.createRecord('c9183cc4', component.options)
    } else {
      api.reload('c9183cc4', component.options)
    }
    module.hot.accept("./warehousing.vue?vue&type=template&id=c9183cc4&", function () {
      api.rerender('c9183cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/OMS/warehousing.vue"
export default component.exports